export default "__VITE_ASSET__qgUY9HsA__"